import React from 'react'
import { Dropdown } from 'react-bootstrap'
import moment from 'moment'
import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'
import CLIENT_ROUTES from '../../../constants/client-endpoints'

const ExperiencesEditMenu = ({
    experience = {},
}) => {
    const { isAdmin, isFacilitator, currentUser } = useCurrentUser()
    const { toLocation } = useClientLocation()
    const url = `${CLIENT_ROUTES.EXPERIENCE.replace(':experienceId', experience.id)}${CLIENT_ROUTES.EDIT}`

    const canEditByDate = moment().isSameOrBefore(experience.date, 'day')
    const canEditByRole =  isAdmin || (isFacilitator && experience.facilitatorId === currentUser.id )
    const canEdit = canEditByDate && canEditByRole

    return (
        <Dropdown.Item
            onClick={() => toLocation(url)}
            disabled={!canEdit}
        >
            Edit
        </Dropdown.Item>
    )
}

export default ExperiencesEditMenu